import { FetchSnippetProps } from '../serverTypes';
import { codeSnippetsServiceUrl } from './snippetsServiceConfig';

const DEFAULT_SERVICE_URL = `${codeSnippetsServiceUrl}/v1/generate-code-snippets`;
const FETCH_SNIPPETS_KEYS: (keyof FetchSnippetProps)[] = ['url', 'sdkIds', 'options'];

/**
 * Extract truthy props from fetchSnippetProps
 * @param fetchSnippetProps
 */
export const generateFetchRequestBody = (fetchSnippetProps: FetchSnippetProps): Record<string, unknown> => {
  const body: Record<string, unknown> = {};
  FETCH_SNIPPETS_KEYS.forEach((key) => {
    const value = fetchSnippetProps[key];
    if (value) {
      body[key] = value;
    }
  });

  return body;
};

/**
 * Generate url used for fetching from code snippets service.
 * Stringifies the needed query params from given options.
 * @param options
 */
export const getSnippetsServiceUrl = (options: FetchSnippetProps): string => {
  return options.serviceUrl || DEFAULT_SERVICE_URL;
};
